module.exports = __webpack_public_path__ + "static/media/envio.84cfedfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/product-step/scrapping/envio.png
// module id = 1649
// module chunks = 0